import Vue from 'vue';
import axios, { AxiosRequestConfig } from 'axios';
import { Loading, Message } from 'element-ui';
import { apis } from '../apis/index';
import { Api } from '../types/Api';
import { routerLogin } from '../utils/utils';
interface BadRequest {
    // http错误码
    status: number;
    // 业务错误码的常量key
    code: string;
    // 业务错误码
    errno: string;
    // 错误信息
    message: string;
    // codes.json的key
    module: string;
}

/**
 * 格式化http异常
 * @param error axios抛出的异常对象
 * @param url 请求的URL
 * @returns 标准异常
 */
function getBadReqReturn(error: any, url: string) {
    console.error(`api:${url} 接口网络错误`);
    let response: BadRequest;
    if (/Network Error/i.test(error.message)) {
        // 断网
        response = {
            status: 400,
            code: 'WEBSITE_NETWORK_ERROR',
            errno: 'E0',
            message: '网络异常，请查看网络连接',
            module: 'front_end',
        };
        Message.error('网络异常，请查看网络连接');
    } else if (error.request && error.request.readyState == 4 && error.request.status == 0) {
        // 超时
        response = {
            status: 400,
            code: 'WEBSITE_NETWORK_TIMEOUT',
            errno: 'E0',
            message: '网络异常，请查看网络连接',
            module: 'front_end',
        };
        Message.error('您的请求超时');
    } else {
        // 业务异常
        response = {
            status: error.response.status,
            code: error.response.data.code,
            errno: error.response.data.errno,
            message: error.response.data.message,
            module: error.response.data.module,
        };
    }
    return response;
}

const instance = axios.create({
    baseURL: `${location.origin}/api`,
    timeout: 30000,
});

// let loading;
// let loadingNumber = 0;
// key url 的 key
// params 参数
// layer 是否展示 loading
// cache 如果本地有则本地获取，然后缓存当前数据。如果第一次本地没有数据则显示loading
function $axios(key: string, params: any, layer = true, cache = false) {
    const api: Api = apis[key];
    const { url, method } = api;

    return new Promise((resolve, reject) => {
        const cacheKey = `${method}:${url}:${JSON.stringify(params)}`;
        let isCacheData = false;
        // 判断是否从本地缓存取数据
        if (cache) {
            // 判断本地是否有数据
            const localStorageData = window.localStorage.getItem(cacheKey);
            if (localStorageData) {
                resolve(JSON.parse(localStorageData));
                isCacheData = true;
            }
        }

        // 参考https://element.eleme.io/#/zh-CN/component/quickstart， https://element.eleme.io/#/zh-CN/component/loading 中Loading的用法
        const isStatisticUrl = /(?=statistic)/.test(url); // 是否是统计模块，统计模块不加载 loading
        // if (layer && !loading && !isStatisticUrl) {
        //     loading = Loading.service({
        //         text: '加载中...',
        //     });
        // }

        // loadingNumber++;
        const isGetMethod = /^get$/i.test(method); // 判断是否是get请求

        instance({
            method: method,
            url: url,
            data: !isGetMethod ? params : null, // 非get请求通过 data 字段传参
            params: isGetMethod ? params : null, // get请求通过 params 字段传参
        } as AxiosRequestConfig)
            .then(data => {
                // loadingNumber--;
                // // 解决多次触发闪烁
                // if (loadingNumber <= 0) {
                //     loading && loading.close();
                //     loading = null;
                //     loadingNumber = 0;
                // }
                // 缓存数据
                if (cache) {
                    window.localStorage.setItem(cacheKey, JSON.stringify(data));
                }
                // 没有缓存返回数据
                if (!isCacheData) {
                    resolve(data);
                }
            })
            .catch(error => {
                // loadingNumber = 0;
                // loading && loading.close();
                // loading = null;
                if (error.response && error.response.status === 401 && error.response.data.code === 'UNAUTHORIZED') {
                    // 根据产品要求，2 秒再跳转登陆
                    Vue.prototype.$message.error('未登录，2 秒后跳转登录');
                    // 向主站发postMessage
                    setTimeout(() => {
                        routerLogin();
                    }, 2000);
                    return;
                } else {
                    Message.error((error.response && error.response.data && error.response.data.message) || '接口错误');
                }
                const response = getBadReqReturn(error, url);
                reject(response);
            });
    });
}

// 参考文档：https://cn.vuejs.org/v2/guide/typescript.html
declare module 'vue/types/vue' {
    // 3. 声明为 Vue 补充的东西
    interface Vue {
        $axios: Function;
    }
}

// 参考文档：https://cn.vuejs.org/v2/guide/plugins.html#ad
Vue.use({
    install: function(Vue: any) {
        // 1. 添加全局方法或 property
        Vue.$axios = $axios;

        // 4. 添加实例方法
        Vue.prototype.$axios = $axios;
    },
});

export { $axios };
